import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorConnection = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M3.25 16.194V8A4.75 4.75 0 0 1 8 3.25h8.106v1.5H8A3.25 3.25 0 0 0 4.75 8v8.194h-1.5Zm5.178 3.056H16A3.25 3.25 0 0 0 19.25 16V8.783h1.5V16A4.75 4.75 0 0 1 16 20.75H8.428v-1.5Z"
    />
    <path
      fill="#F7A600"
      d="M18.6 3.55a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM14.85 5.8a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM6 15.85a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM2.25 18.1a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Z"
    />
  </svg>
);
export default SvgTwoColorConnection;
